import { SigninFieldsRequest } from './signin-fields-request';

export class SignerRequest {
  public Firstname?: string;
  public LastName?: string;
  public EmailAdress?: string;
  public Language?: string;
  public BirthDate?: string;
  public ExternalStakeholderReference?: string;
  public PhoneNumber?: string;
  public SigningType?: string;
  public SigningField: SigninFieldsRequest;
}
